import { useTranslation } from 'react-i18next';

import { FiltersHandler } from './FiltersHandler';
import { FiltersWrapper, TitleWrapper, Wrapper } from './StudentsHeader.styles';
import { StudentsSearch } from './StudentsSearch';

export const StudentsHeader = () => {
  const { t } = useTranslation('CourseTranslations');

  return (
    <Wrapper>
      <TitleWrapper>{t('COURSE_STUDENTS')}</TitleWrapper>
      <FiltersWrapper>
        <StudentsSearch />
        <FiltersHandler />
      </FiltersWrapper>
    </Wrapper>
  );
};
